// CANONICAL COPY (GH #7115). src/constants/obligations/obl-infrastructure-redundancy.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-infrastructure-redundancy',
  title: 'Verify redundancy of processing facilities',
  description:
    'Confirm that information processing facilities incorporate adequate redundancy to satisfy availability requirements defined by the business continuity objectives. Review the architecture and failover testing records for critical systems, and document any capacity or redundancy gaps.',
  category: 'technical',
  scfIds: ['SCF-OPS-011'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Redundancy / high-availability design documentation is published',
    },
    { type: 'document-within-sla', description: 'Design documentation review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
